import { Flex, IconButton, OpenIcon, Text, VisibleIcon } from "@minervaproject/fds";
import { useContext, useEffect } from "react";

import { createResourceHelper } from "api/api_helpers";
import { CaptionsDoc } from "components/captioning/caption_doc";
import { NonVisibleIcon } from "components/captioning/non_visible_icon";
import { ForumAPIContext } from "contexts/forum_api_context";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { useUserProperties } from "hooks/use_user_properties";
import { setUserEnableLiveCaptions } from "shared/reducers/classroom";
import { MinervaResourceSubtypeType, ResourceTypeType } from "shared/types";
import {
  selectClassId,
  selectCurrentUserIsCaptionsLeader,
  selectLiveCaptionResource,
} from "store/selectors/classroom";
import { selectCurrentUserId } from "store/selectors/local";

function CaptionsInput() {
  const dispatch = useAppDispatch();
  const forumAPI = useContext(ForumAPIContext);
  const classId = useAppSelector(selectClassId());
  const currentUserId = useAppSelector(selectCurrentUserId());
  const user = useUserProperties(currentUserId, ["enable_live_captions"]);
  const { enable_live_captions } = user || {};
  const isCaptionsLeader = useAppSelector(selectCurrentUserIsCaptionsLeader());
  const captionsDoc = useAppSelector(selectLiveCaptionResource());

  const handleToggleLiveCaptions = () => {
    dispatch(
      setUserEnableLiveCaptions({
        userId: currentUserId,
        enableLiveCaptions: !enable_live_captions,
      }),
    );
  };

  const handleOpenInNewTab = async () => {
    if (!captionsDoc) return;
    const url = await forumAPI.getForumDocSignedUrl(captionsDoc.id);
    window.open(url, "_blank");
    window.focus();
  };

  useEffect(() => {
    if (isCaptionsLeader && !captionsDoc) {
      createResourceHelper(classId, ResourceTypeType.ForumDoc, dispatch, forumAPI, {
        minervaResourceSubtype: MinervaResourceSubtypeType.CaptionsDoc,
      });
    }
  }, [dispatch, forumAPI, classId, isCaptionsLeader, captionsDoc]);

  if (!user) {
    return null;
  }

  return (
    <Flex auto direction="column" className="sidebar-width">
      <Flex auto className="justify-between">
        <Text className="body-l" kind="h2" p={2}>
          Captions
        </Text>
        <div>
          <Flex auto p={2}>
            <IconButton onClick={handleToggleLiveCaptions} aria-label="Toggle captions on stage">
              {enable_live_captions ? (
                <VisibleIcon width={16} height={16} color="#B3B3B3" />
              ) : (
                <NonVisibleIcon width={16} height={16} />
              )}
            </IconButton>
            <IconButton onClick={handleOpenInNewTab} aria-label="Open in a new tab">
              <OpenIcon width={16} height={16} color="#B3B3B3" />
            </IconButton>
          </Flex>
        </div>
      </Flex>
      {captionsDoc && <CaptionsDoc />}
    </Flex>
  );
}

export { CaptionsInput };
